import React from 'react'
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg'
import CheckBox from 'shared/ui/CheckBox/CheckBox'
import { SortableHeaderCell } from 'shared/components/DataTable/components/SortableHeaderCell/SortableHeaderCell'
import s from './ColumnsHeader.module.scss'

const mkSortOptions = (key, labels) => [
	{ id: `${key}_asc`, key, dir: 'asc', label: labels?.asc || 'A → Z' },
	{ id: `${key}_desc`, key, dir: 'desc', label: labels?.desc || 'Z → A' },
]

const SORT_OPTIONS_BY_COLUMN = {
	student: mkSortOptions('student', { asc: 'A → Z', desc: 'Z → A' }),
	university: mkSortOptions('university', { asc: 'A → Z', desc: 'Z → A' }),
	deadline: mkSortOptions('deadline', {
		asc: 'Oldest → Newest',
		desc: 'Newest → Oldest',
	}),
}

const COLUMNS = [
	{ id: 'student', label: 'Student', sortable: true },
	{ id: 'university', label: 'University / Program', sortable: true },
	{ id: 'attention', label: 'Attention', sortable: false },
	{ id: 'deadline', label: 'Deadline', sortable: true },
]

const ColumnsHeader = ({
	allSelected = false,
	onToggleAll,
	sortKey,
	sortDir,
	onSortSelect,
	onOpenFilter,
	isFilterOpen = false,
	showSelect = true,
	showStudent = true,
}) => {
	const columns = COLUMNS.filter(col => showStudent || col.id !== 'student')

	return (
		<div className={s.row}>
			{showSelect && (
				<div className={s.check}>
					<CheckBox isSelected={allSelected} onToggle={onToggleAll} />
				</div>
			)}

			{columns.map(col => (
				<div key={col.id} className={`${s.cell} ${s[col.id]}`}>
					{col.sortable ? (
						<SortableHeaderCell
							className={s.sortHead}
							labelClassName={s.sortLabel}
							label={col.label}
							isActive={sortKey === col.id}
							dir={sortDir}
							options={SORT_OPTIONS_BY_COLUMN[col.id] || []}
							onSelect={opt => onSortSelect?.({ opt, name: col.label })}
						/>
					) : (
						<span className={s.label}>{col.label}</span>
					)}
				</div>
			))}

			<div className={s.filterCell}>
				{onOpenFilter && !isFilterOpen && (
					<button
						type="button"
						className={s.filterBtn}
						onClick={onOpenFilter}
						aria-label="Open filters"
					>
						<span className={s.filterBtnIcon} aria-hidden="true">
							<FilterIcon />
						</span>
					</button>
				)}
			</div>
		</div>
	)
}

export default ColumnsHeader
